import React from 'react'
import Spinner from '~/components/Spinner';
import { hide, setupPin, viewingRestrictions } from "~/views/Popup/popup";
import store from '~/redux/user/store';
import { setPinInSession } from './setPinInSession';
import { setParentalControls, updateRating } from '~/redux/user/actions';
import { setParentalControlToggle } from '~/components/ToggleSwitch/setParentalControlToggle'
import { getLocalizedVal } from '~/tools/localization/helpers'
import { getUserPin } from '~/tools/isPinSet';
import './style.scss'
import jwtDecode from 'jwt-decode'
import { getToken } from '~/redux/user/tokens'
import { userLanguageSelector } from '~/tools/localization'
import { axiosWithKey } from "~/axios"

class PinOverlay extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            error: '',
            processing: '',
            pins: '',
            askPin: props.askPin || props.args.askPin,
            popupFlow: (props.args && props.args.askPin) || false,
            textBoxStyle : {
                "border": "1px solid #616161"
            },
            rating: (props.args && props.args.rating) || false,
            localizedFields: {}

        }
        this.pinsRef = [];
        this.pinBoxes = [1, 2, 3, 4];
    }

    componentDidMount() {
        this.fetchPageData();
    }
    handleState = (event, nextFieldID) => {
        const { name, value } = event.target;

        if (Number(event.target.value) >= 0) {
            
            this.setState({[name]: value});
            this.moveOnMax(event, value, nextFieldID);

        } else {
            this.setState({[name]: ''});
        }
    }
    fetchPageData = () => {
        getToken(token => {
            var decodedToken = jwtDecode(token);
		    var tokenCountryCode = decodedToken.countryCode
            let baseUrl = ""
            if(window.settings.apiBaseUrl === "https://prod-api.viewlift.com") {
                baseUrl = "https://prod-api-cached-2.viewlift.com"
            } else {
                baseUrl = window.settings.apiBaseUrlCached || window.settings.apiBaseUrl
            }
            var contentApiHeaders = {
                Authorization: token,
                'x-api-key': window.settings.baseAPIKey,
              }
          return axiosWithKey({
            method: "GET",
            url: `${baseUrl}/content/pages?path=/user&languageCode=${userLanguageSelector()}&includeContent=true&countryCode=${tokenCountryCode}`,
            headers: contentApiHeaders
          })
            .then(res => {
              const response = res.data && res.data.modules[1]
                this.setState({localizedFields: response.metadataMap})
            })
            .catch();
        });
      }
    moveOnMax = (event, fieldValue, nextFieldID) => {
        if (fieldValue && fieldValue.length === 1 && nextFieldID < 5) {
            document.getElementById('pinOverlay' + this.state.rating + nextFieldID).focus();
        } else if (fieldValue && fieldValue.length === 1 && nextFieldID === 5) {
            document.getElementById('pinOverlay' + this.state.rating + (nextFieldID-1)).blur();
            this.combinedPins(nextFieldID);
            this.handleSubmit(event);
        }
    }

    combinedPins = (nextFieldID) => {
        const videoPins = [];

        this.pinsRef && this.pinsRef.length > 0 &&  this.pinsRef.map((refItem) => {
            videoPins.push(refItem.value);

            if (videoPins && videoPins.length === (nextFieldID - 1) ) {
                const videoPinString = videoPins.join("")
                this.setState({ pins: videoPinString})
            }
        })
    }

    handleSubmit = async (event) => {
        await event.preventDefault()
        const pattern =  /[0-9]{4}/g;

        if (!this.state.pins || this.state.pins.length < 4) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','validPinError') || 'Enter valid PIN');
            return false;
        } else if (!(pattern.test(this.state.pins))) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','validPinError') || 'Enter valid PIN');
            return false;
        } else {    
            this.setState({ processing: true });
        }
        
        const getStoredPin = getUserPin();
        if(this.state.pins === getStoredPin) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','correctPinMessage') || "The PIN is correct");
            
            const getToggleFlag = this.props && this.props.args && this.props.args.parentalControlToogle;
            if(getToggleFlag) {
                if(setParentalControlToggle(getToggleFlag)) {
                    this.props.args.updateParentalControlToogle();
                    this.setState({ processing: false });
                    hide();
                } else {
                    this.alert(getLocalizedVal(window.settings,'genericMessages','errorOccurredMessage') || "An error occurred");
                    this.setState({ processing: false });
                }  
            } else {
                this.setState({ processing: true});
                
                if (this.props.videoId && getStoredPin) {
                    const user = store.getState().user;
                    user && setPinInSession(getStoredPin, user);
                    if(this.props.initializePlayer()) {
                        this.props.initializePlayer()
                    }
                }

                if(!this.state.popupFlow) {
                    this.props.changePinState();
                    this.setState({ processing: false , askPin: false,  textBoxStyle: {"border" : "1px solid #616161"}});
                } else if(this.state.popupFlow) {
                    if(this.state.rating) {
                        let userRating = {
                            "parentalRating": this.state.rating
                        }
                        this.setState({ processing: true}, this.saveRating(userRating))
                    }
                } else {
                    this.setState({ processing: false});
                }
            }
            
        } else {
            this.alert(getLocalizedVal(window.settings,'genericMessages','inCorrectPinMessage') || "Incorrect PIN. Please try again");
            this.setState({ pinsRef: [], processing: false, textBoxStyle: {"border" : "1px solid red"} });
            return false;
        } 
    }
    
    saveRating(userRating) {
        setParentalControls(userRating)
        .then(response => { 
            if (response && response.status === 200) {
                store.dispatch(updateRating(this.state.rating))
                this.setState({ processing: false})
                hide()
            } else {
                this.alert(getLocalizedVal(window.settings,'genericMessages','unableSetPin') || 'Unable to set the PIN' || response.data.error);
                return false;
            }
        })
    }

    alert(msg) {
        this.setState({ error: msg })
        setTimeout(_ => this.setState({ error: null }), 8000)
    }

    render() {
        if(this.state.processing) {
            return <div className="loading-centered"><Spinner /></div>
        }

        const requirePin = this.state.askPin
        if(!requirePin) {
            return <div></div>
        }
        
        return (
            <div className="cascadesContainer">
            <div className="modal flexColumn pinModal">
                <div className="title">{getLocalizedVal(window.settings,'genericMessages','viewingRestrictionsEnabled') || "Viewing Restrictions Enabled"}
                    <div className="closePlayer html5"></div>
                </div>
                <div className="description">{getLocalizedVal(window.settings,'genericMessages','enterVideoPin') || "Please enter your PIN:"}
                    <div className="pinFields">
                        { this.pinBoxes && this.pinBoxes.length > 0 && this.pinBoxes.map((index)=>{
                            const autoFocusTxt = index === 1 ? true: false;
                            return (<input type="password" key={index} style={this.state.textBoxStyle} className="pinField" id={`pinOverlay`+ this.state.rating + index} ref={(refItem) => this.pinsRef[index] = refItem} onKeyUp={(event) =>  this.handleState(event, index+1)} maxlength="1" autoComplete="false" autoFocus={ autoFocusTxt }
                            required/>)
                        })}
                    </div>
                    {this.state.processing && <div className="loading-centered"><Spinner /></div>}

                    {this.state.error && <div className="error">{this.state.error}</div>}
                    <div className="notes">
                        <span className="hand" onClick={_=> setupPin({args: this.state.localizedFields})}>
                        {getLocalizedVal(window.settings,'genericMessages','resetYourPin') || "Reset your PIN"}
                        </span> 
                        <span>&nbsp; OR  &nbsp;</span>  
                        <span className="hand" onClick={_=> viewingRestrictions({args: this.state.localizedFields})}>
                        {getLocalizedVal(window.settings,'genericMessages','changeViewingRestrictions') || "Change viewing restrictions"}
                        </span>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}

export default PinOverlay;